import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tokens.css'
import './assets/utilities.css'

createApp(App).use(router).mount('#app')
